import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["list", "view", "mainCard", "bodyTable", "footerTable", "checkboxShow", "opportunityLeadName",
                    "countOneCheckbox", "countOne", "countTwoCheckbox", "countTwo"]

  connect() {
    this.controllerName = `financials--books--statements--balances--index`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
    this.itemsOnPage = 300
    this.pageNumber = 0
    this.numberPages = []
    this.sort = { mode: `asc`, field: `token` }
    this.hasShow = false
    this.tableCols = 12
  }

  showBalance(ev) {
    var controllerShow = this.getControllerByIdentifier("financials--books--statements--balances--show")

    if (this.checked_id == ev.target.closest(".itemRow").dataset.id) {
      this.hasShow = false
    } else {
      this.hasShow = true
      this.checked_id = ev.target.closest(".itemRow").dataset.id
    }

    if (this.hasShow) {
      this.checkboxShowTargets.forEach(element => {
        if (checkBoxElement != element) {
          element.checked = false
        }
      })
      this.application.opportunities.forEach(element => {
        if (element.id == this.checked_id) {
          controllerShow.current_opportunity = element
        }
      })
      controllerShow.doBalanceHtml()
    } else {
      if (controllerShow.hasPreviewCardTarget) {
        controllerShow.doViewHtml()
      } else {
        controllerShow.doBalanceHtml()
      }
    }
  }

  addBalance() {
    this.getControllerByIdentifier("financials--books--statements--balances--save").actionMode = "new"
    this.getControllerByIdentifier("financials--books--statements--balances--save").doFormHtml()
  }

  editBalance(ev) {
    var id = ev.currentTarget.closest(".itemRow").dataset.id
    this.application.balances.forEach(element => {
      if (element.id == id) {
        this.getControllerByIdentifier("financials--books--statements--balances--save").current_balance = element
      }
    })
    this.getControllerByIdentifier("financials--books--statements--balances--save").actionMode = "edit"
    this.getControllerByIdentifier("financials--books--statements--balances--save").doFormHtml()
  }

  sortTable(ev) {
    var mode = ev.currentTarget.dataset.mode
    var field = ev.currentTarget.dataset.field

    if (mode == `desc`) {
      ev.currentTarget.nextElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    } else if (mode == `asc`) {
      ev.currentTarget.previousElementSibling.classList.remove("d-none")
      ev.currentTarget.classList.add("d-none")
    }

    this.sort.mode = mode
    this.sort.field = field
    this.doDataTable()
  }

  updateBalance() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
    this.bodyTableTarget.innerHTML = this.getControllerByIdentifier(`app--helpers--table`).doTablePreloader(this.tableCols, 10)

    this.send_data = { current_user: {}, balance: {} }
    this.send_data.balance.date_id = this.application.current_date.id

    this.send_data.current_user.current_user_id = this.application.current_user.id
    this.send_data.current_user.feature = `financial_statement_balances`

    var url = "/financials/books/statements/balances/refresh"
    var method = "PUT"
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var balanceIds = controller.mapElements(controller.application.balances, `id`)

          response.data.cln.forEach(balance => {
            if (balanceIds.includes(balance.id)) {
              controller.application.balances.forEach((element, i) => {
                if (element.id == balance.id) {
                  controller.application.balances.splice(controller.application.balances.indexOf(element), 1, balance)
                }
              })
            } else {
              controller.application.balances[controller.application.balances.length] = balance
            }
          })
        }
        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  listBalance() {
    this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
    this.bodyTableTarget.innerHTML = this.getControllerByIdentifier(`app--helpers--table`).doTablePreloader(this.tableCols, 10)

    const data = { balance: { active: true, date_id: this.application.current_date.id }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_statement_balances` } }
    const url = "/financials/books/statements/balances/list_by_date"
    const init = { method: "POST", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
    var controller = this
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.process) {
          var currentBalanceIds = controller.mapElements(controller.application.balances, `id`)
          var refreshBalanceIds = controller.mapElements(response.data.cln, `id`)

          if (response.data.cln.length > 0) {
            response.data.cln.forEach(balance => {
              if (currentBalanceIds.includes(balance.id) && refreshBalanceIds.includes(balance.id)) {
                controller.application.balances.forEach((element, i) => {
                  if (element.id == balance.id) {
                    controller.application.balances.splice(controller.application.balances.indexOf(element), 1, balance)
                  }
                })
              } else if (currentBalanceIds.includes(balance.id)) {
                controller.application.balances.forEach((element, i) => {
                  if (element.id == balance.id) {
                    controller.application.balances.splice(controller.application.balances.indexOf(element), 1)
                  }
                })
              } else if (refreshBalanceIds.includes(balance.id)) {
                controller.application.balances[controller.application.balances.length] = balance
              }
            })  
          } else {
            controller.application.balances.forEach((element, i) => {
              if (element.date_id == this.application.current_date.id) {
                controller.application.balances.splice(controller.application.balances.indexOf(element), 1)
              }
            })
          }
          
        }

        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
  }

  destroyAllBalances() {
    var r = confirm(`Tem certeza que deseja apagar todas as Contas de Balanço?`)
    if (r) {
      this.getControllerByIdentifier(`app--helpers--pre-modal`).openProcessModal()
      this.bodyTableTarget.innerHTML = this.getControllerByIdentifier(`app--helpers--table`).doTablePreloader(this.tableCols, 10)
      
      const data = { balance: { active: true, date_id: this.application.current_date.id }, current_user: { current_user_id: this.application.current_user.id, feature: `financial_statement_balances` } }
      const url = "/financials/books/statements/balances/destroy_by_date"
      const init = { method: "DELETE", credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(data) }
      var controller = this
      fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var destroyedBalanceIds = controller.mapElements(response.data.cln, `id`)
          var array = controller.application.balances
          for (var index = 0; index < array.length; index++) {
            var element = array[index]

            if (destroyedBalanceIds.includes(element.id)) {
              controller.application.balances.splice(controller.application.balances.indexOf(element), 1)
              index--
            }
          }
        }
        
        controller.doDataTable()
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).finalResponse(response)
      })
      .catch(error => {
        controller.getControllerByIdentifier(`app--helpers--fetch-response`).catchError(error)
      })
    }
  }

  doIndexListHtml() {

    if (this.application.permissions.financial_statement_balances.can_delete && this.application.current_user.super_admin) {
      var destroyLine = `<span data-action="click->${this.controllerName}#destroyAllBalances" class="dropdown-item py-1 pointer dropdown-submenu-item">Apagar Contas de Balanço</span>`
    } else {
      var destroyLine = ``
    }
    var destroyLine = ``

    if (this.application.permissions.financial_statement_balances.can_create && this.application.current_user.super_admin) {
      var addLine = `<span data-action="click->${this.controllerName}#addBalance" class="dropdown-item py-1 pointer dropdown-submenu-item">Adicionar Conta de Balanço</span>`
    } else {
      var addLine = ``
    }

    var refreshLine = `<span data-action="click->${this.controllerName}#listBalance" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Contas de Balanço</span>`
    var updateLine = `<span data-action="click->${this.controllerName}#updateBalance" class="dropdown-item py-1 pointer dropdown-submenu-item">Atualizar Saldo das Contas de Balanço</span>`

    var clearBtnHtml = `<span class="mc-tooltip">
                          <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0 d-none" data-${this.controllerName}-target="clearListBtn" data-action="click->${this.controllerName}#clearList" type="button">
                            <span class="material-icons md-dark">clear</span>
                          </button>
                          <span class="mc-tooltiptext">Limpar</span>
                        </span>`

    var submenuHtml = `<div class="dropdown mc-tooltip" data-${this.controllerName}-target="optionBtn">
                        <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-toggle="dropdown" id="submenuMenuDrop" type="button"><span class="material-icons md-dark">more_vert</span></button>
                        <div aria-labelledby="submenuMenuDrop" class="dropdown-menu dropdown-menu-right menu" style="font-size:80%">
                          ${addLine}
                          ${refreshLine}
                          ${updateLine}
                          ${destroyLine}
                        </div>
                        <span class="mc-tooltiptext">Opções</span>
                      </div>`
    
    var html = `<div class="row">
                  <div class="col-11 px-1">
                    <div class="card" style="width:100%;display:relative;" data-controller="app--helpers--search" data-${this.controllerName}-target="mainCard" data-action="resize@window->${this.controllerName}#layout">
                      <div class="card-header d-flex align-items-center card-header-table-list f-065">
                        <h6 class="card-title display-4 card-title-table-list">Contas de Balanço</h6>
                        <input class="form-control f-070 w-50 mx-auto" data-app--helpers--search-target="searchInput" data-action="keyup->app--helpers--search#doSearchTable" placeholder="Buscar ..." type="text">
                        <div class="card-actions ml-auto py-0">
                          ${clearBtnHtml}
                          ${submenuHtml}
                        </div>
                      </div>
                      <div class="card-body py-0" style="overflow:auto;">
                        <div class="row">
                          <div class="col p-0">
                            <table class="table table-sm table-hover" data-app--helpers--search-target="searchTable" style="font-size:80%;">
                              <thead>
                                <tr>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-3 align-middle"></th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">
                                    Empresa
                                    <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="med_name" data-mode="desc">south</span>
                                    <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="med_name" data-mode="asc">north</span>
                                  </th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-5 align-middle">
                                    Data
                                    <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="date_pretty" data-mode="desc">south</span>
                                    <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="date_pretty" data-mode="asc">north</span>
                                  </th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-20 align-middle">
                                    Conta de Balanço
                                    <span class="material-icons md-sm md-dark" data-action="click->${this.controllerName}#sortTable" data-field="chart_name" data-mode="desc">south</span>
                                    <span class="material-icons md-sm md-dark d-none" data-action="click->${this.controllerName}#sortTable" data-field="chart_name" data-mode="asc">north</span>
                                  </th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-10 align-middle">Grupo de Conta</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">Tipo</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Saldo Inicial</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Origem</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Destino</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle text-center">Saldo Final</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-8 align-middle">Tipo de Conta</th>
                                  <th style="font-size:80%;" scope="col" class="pointer p-1 table-3 align-middle"></th>
                                </tr>
                              </thead>
                              <tbody data-${this.controllerName}-target="bodyTable">
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="card-footer py-0" data-${this.controllerName}-target="footerTable">
                      </div>
                    </div>
                  </div>
                  <div class="col-1 px-1">
                    <div class="card">
                      <div class="card-header p-1 text-center f-070 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-30 my-0 d-flex">
                          <input type="checkbox" class="custom-control-input" id="countOneCheck" data-${this.controllerName}-target="countOneCheckbox" data-kind="countOne" data-action="click->${this.controllerName}#kindCheck">
                          <label class="custom-control-label f-065" for="countOneCheck"></label>
                        </div>
                        <span><strong>Soma 1</strong></span>
                      </div>
                      <div class="card-body text-center f-070 px-1 py-4">
                        <span data-${this.controllerName}-target="countOne"></span>
                      </div>
                    </div>
                    <div class="card mt-5">
                      <div class="card-header p-1 text-center f-070 d-flex align-items-center">
                        <div class="custom-control custom-checkbox pr-0 pl-2 w-30 my-0 d-flex">
                          <input type="checkbox" class="custom-control-input" id="countTwoCheck" data-${this.controllerName}-target="countTwoCheckbox" data-kind="countTwo" data-action="click->${this.controllerName}#kindCheck">
                          <label class="custom-control-label f-065" for="countTwoCheck"></label>
                        </div>
                        <span><strong>Soma 2</strong></span>
                      </div>
                      <div class="card-body text-center f-070 px-1 py-4">
                        <span data-${this.controllerName}-target="countTwo"></span>
                      </div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--books--statements--balances--dashboard").contentTarget.innerHTML = html)
    }).then(() => {
      controller.mainCardTarget.style.height = ($(window).height() * 0.65) + "px"
      controller.bodyTableTarget.insertAdjacentHTML("beforeend", controller.getControllerByIdentifier("app--helpers--table").doTablePreloader(this.tableCols, 10))
      controller.doDataTable()
      controller.countOneTarget.innerText = controller.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(0)
      controller.countTwoTarget.innerText = controller.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(0)
    })
  }

  doDataTable() {
    var current_balances = []

    this.application.balances.forEach(balance => {
      if (this.application.current_med.id) {
        if (this.application.current_date.id == balance.date_id && this.application.current_med.id == balance.med_id) {
          current_balances[current_balances.length] = balance
        }
      } else {
        if (this.application.current_date.id == balance.date_id) {
          current_balances[current_balances.length] = balance
        }
      }
    })

    if (this.sort.mode == `asc`) {
      var balances = this.getControllerByIdentifier("app--helpers--data").sortByKeyAsc(current_balances, this.sort.field)
    } else if (this.sort.mode == `desc`) {
      var balances = this.getControllerByIdentifier("app--helpers--data").sortByKeyDesc(current_balances, this.sort.field)
    }

    if (balances.length == 0) {
      var pagination = { itemsOnPage: 0, fromItem: 0, toItem: 0, totalItems: 0 }
      this.listData()
      this.doFooterTable(pagination)
    } else {
      var itemsOnPage = this.itemsOnPage
      var pageNumber = this.pageNumber
      var numberPages = this.numberPages
      var pages = []
      var itemLoop = Math.ceil(balances.length / itemsOnPage)
      var x = 0
      var i = 1
      for (i; i < itemLoop + 1; i++) {
        var internPage = []
        for (x; x < itemsOnPage * i; x++) {
          if (balances[x] !== undefined) {
            internPage[internPage.length] = balances[x]
          }
        }
        pages[pages.length] = internPage
        numberPages[numberPages.length] = i - 1
      }

      var fromItem = itemsOnPage * pageNumber + 1
      var toItem = Math.min(itemsOnPage * (pageNumber + 1), (itemsOnPage * pageNumber) + pages[pageNumber].length)
      var pagination = { itemsOnPage: itemsOnPage, fromItem: fromItem, toItem: toItem, totalItems: balances.length }
      this.listData(pages[pageNumber])
      this.doFooterTable(pagination)
    }
  }

  listData(data) {
    this.bodyTableTarget.innerHTML = ""
    if (data == undefined || data == [] || data.length == 0) {
      var noData = `</tr>
                      <td colspan="${this.tableCols}" class="p-3 align-middle text-center" style="font-size:100%;">
                        <span class="fa-stack fa-1x">
                          <i class="fas fa-list fa-stack-1x"></i>
                        </span>
                        <span class="f-075 align-middle">Não há Contas de Balanço</span>
                      </td>
                    </tr>`

      this.bodyTableTarget.innerHTML = noData
    } else {
      data.forEach(element => {
        this.bodyTableTarget.insertAdjacentHTML("beforeend", this.balanceTablePartial(element, data.length))
      });
    }

    if (this.checked_id) {
      this.checkboxShowTargets.forEach(element => {
        if (element.id == `check-${this.checked_id}`) {
          element.checked = true
        }
      })
    }
  }

  balanceTablePartial(element, length) {

    if (this.application.permissions.financial_statement_balances.can_update) {
      var edit = `<button data-action="click->${this.controllerName}#editBalance" type="button" class="btn btn-sm btn-table p-0 mc-tooltip">
                    <span class="material-icons md-sm md-dark">edit</span>
                    <span class="mc-tooltiptext">Editar</span>
                  </button>`
    } else {
      var edit = ``
    }

    if (length == 1) {
      var tableRow = `<tr class="itemRow" data-id="${element.id}" style="height:50px;">`
    } else {
      var tableRow = `<tr class="itemRow" data-id="${element.id}">`
    }

    var rowHtml = `${tableRow}
                    
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">
                      <div class="custom-control custom-checkbox pr-0 pl-2 w-50 my-0 d-flex">
                        <input disabled type="checkbox" class="custom-control-input" id="check-${element.id}" data-${this.controllerName}-target="check-${element.id}" data-action="click->${this.controllerName}#countBalance">
                        <label class="custom-control-label f-065" for="check-${element.id}"></label>
                      </div>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.med_name}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.date_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">
                      <small class="mb-0 f-065 mc-tooltip grab">
                        <span data-controller="app--helpers--copy" data-copy="${element.chart_name}" data-action="click->app--helpers--copy#copy">${element.chart_name}</span>
                        <span class="mc-tooltiptext">Clique para Copiar</span>
                      </small>
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.group_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.master_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(element.previous_balance)}
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(element.from_amount)}
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(element.to_amount)}
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle text-center">
                      ${this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(element.balance)}
                    </td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${element.kind_pretty}</td>
                    <td style="font-size:80%;" scope="col" class="p-1 align-middle">${edit}</td>
                  </tr>`

    return rowHtml
  }

  itemsLength(ev) {
    this.itemsOnPage = ev.target.dataset.items
    this.pageNumber = 0
    this.numberPages = []
    this.doDataTable()
  }

  previousTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber - 1)) {
      this.pageNumber -= 1
      this.doDataTable()
    }
  }

  nextTablePage(ev) {
    if (this.numberPages.includes(this.pageNumber + 1)) {
      this.pageNumber += 1
      this.doDataTable()
    }
  }

  doFooterTable(pagination) {
    var footerHtml = `<div class="row">
                        <div class="col-3 d-flex">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span data-app--helpers--search-target="footerTable"></span>
                          </div>
                        </div>
                        <div class="col-9 px-0">
                          <div class="card-actions align-items-center justify-content-end py-0 f-065">
                            <span class="align-self-center mb-1 mx-1 text-muted">Itens por Página:</span>
                            <div class="dropdown">
                              <button aria-expanded="false" aria-haspopup="true" class="btn btn-outline dropdown-toggle f-065" data-toggle="dropdown" type="button">${this.controllerNumber.numberMask(pagination.itemsOnPage)}</button>
                              <div class="dropdown-menu dropdown-menu-right menu">
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="300">300</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="750">750</span>
                                <span class="dropdown-item pointer" data-action="click->${this.controllerName}#itemsLength" data-items="1000">1.000</span>
                              </div>
                            </div>
                            <span class="align-self-center mb-1 mr-2 text-muted">${this.controllerNumber.numberMask(pagination.fromItem)}-${this.controllerNumber.numberMask(pagination.toItem)} de ${this.controllerNumber.numberMask(pagination.totalItems)}</span>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#previousTablePage"><i class="material-icons md-sm">chevron_left</i></a>
                            <a class="btn btn-outline py-0" data-action="click->${this.controllerName}#nextTablePage"><i class="material-icons md-sm">chevron_right</i></a>
                          </div>
                        </div>
                      </div>`

    this.footerTableTarget.innerHTML = footerHtml
  }

  kindCheck(ev) {
    this.kind = ev.currentTarget.dataset.kind

    if (this.kind == `countOne`) {
      this.countOneCheckboxTarget.checked = true
      this.countTwoCheckboxTarget.checked = false
    } else if (this.kind == `countTwo`) {
      this.countOneCheckboxTarget.checked = false
      this.countTwoCheckboxTarget.checked = true
    }

    this.application.balances.forEach(balance => {
      if (this.nameTarget(`check-${balance.id}`)) {
        this.nameTarget(`check-${balance.id}`).disabled = false
      }
    });
  }

  countBalance(ev) {
    if (this.kind == `countOne` || this.kind == `countTwo`) {
      var previous = 0
      var value = 0
      var final = 0
      var balanceId = ev.currentTarget.closest(`.itemRow`).dataset.id

      this.application.balances.forEach(balance => {
        if (balance.id == balanceId) {
          value = Number(balance.balance)
        }
      })

      if (ev.currentTarget.checked) {
        if (this.kind == `countOne`) {
          previous = Number(this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.countOneTarget.innerText))
          final = previous + value
          this.countOneTarget.innerText = this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(final)
        } else if (this.kind == `countTwo`) {
          previous = Number(this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.countTwoTarget.innerText))
          final = previous + value
          this.countTwoTarget.innerText = this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(final)
        }
      } else {
        if (this.kind == `countOne`) {
          previous = Number(this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.countOneTarget.innerText))
          final = previous - value
          this.countOneTarget.innerText = this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(final)
        } else if (this.kind == `countTwo`) {
          previous = Number(this.getControllerByIdentifier("app--helpers--numbers").fromCurrencyToNumber(this.countTwoTarget.innerText))
          final = previous - value
          this.countTwoTarget.innerText = this.getControllerByIdentifier("app--helpers--numbers").currencyOptionMask(final)
        }
      }

    }
  }

  cleanCheckBox() {
    this.checkboxShowTargets.forEach(element => {
      element.checked = false
    });
    this.checked_id = ``
  }

  userCanUpdate(ticketId) {
    var ticket = {}
    this.application.in_process_tickets.forEach(element => {
      if (element.id == ticketId) {
        ticket = element
      }
    })
    var allowed = [ticket.owner_id, ticket.performer_id]
    if (allowed.includes(this.application.current_user.account_id) && this.stage != "done") {
      return true
    } else {
      return false
    }
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  goToURL(ev) {
    var url = ev.currentTarget.dataset.url
    window.open(url, `_self`)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  mapElements(array, field) {
    var results = []
    array.forEach(element => {
      results[results.length] = element[field]
    });
    return results
  }

  // var controller = this
  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
